import { useState, useContext } from "react";
import { Modal } from "antd";
import Api from "../Api/request";
import AppContext from "../contexts/appContext";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const useLoginLogic = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const [loading, setLoading] = useState(false);
  const appContext = useContext(AppContext);

  const loginWithEmail = async (email: string, password: string) => {
    const data = { email, password };
    setLoading(true);

    try {
      const response = await Api.post("/api/v1/app/auth/email/signin", data, {
        headers: {
          "Accept-Language": i18next.language,
        },
      });

      if (response.data.ok) {
        appContext.handleLogin(response.data.data.access_token);
        return { success: true, token: response.data.data.access_token };
      } else {
        modal.error({
          centered: true,
          title: t("login.messages.error"),
          closable: true,
          content: response.data.message,
          okButtonProps: {
            className: "bg-gray-100 !text-red-400 hover:!bg-white mt-2.5 mx-auto",
          },
          okText: t("login.okText"),
        });
        return { success: false, error: response.data.message };
      }
    } catch (e: any) {
      modal.error({
        centered: true,
        title: t("login.messages.error"),
        closable: true,
        content: e.response?.data?.message || "An error occurred",
        okButtonProps: {
          className: "btn-primary",
        },
        okText: t("login.okText"),
      });
      return { success: false, error: e.response?.data?.message };
    } finally {
      setLoading(false);
    }
  };

  const loginWithGoogle = async (credential: string) => {
    setLoading(true);
    appContext.handleLoading(true);

    try {
      const response = await Api.post(
        "/api/v1/app/auth/google/join",
        {
          token: credential,
          auth_type: "google_auto_join",
        },
        {
          headers: {
            "Accept-Language": i18next.language,
          },
        }
      );

      if (response.data.ok) {
        appContext.handleLogin(response.data.data.access_token);
        appContext.handleLoading(false);
        return { success: true, token: response.data.data.access_token };
      } else {
        appContext.handleLoading(false);
        modal.error({
          centered: true,
          title: "Error",
          closable: true,
          content: response.data.message,
          okButtonProps: {
            className: "btn-primary",
          },
        });
        return { success: false, error: response.data.message };
      }
    } catch (e: any) {
      appContext.handleLoading(false);
      modal.error({
        centered: true,
        title: "Error",
        closable: true,
        content: e.response?.data?.message || "An error occurred",
        okButtonProps: {
          className: "btn-primary",
        },
      });
      return { success: false, error: e.response?.data?.message };
    } finally {
      setLoading(false);
      appContext.handleLoading(false);
    }
  };

  return {
    loginWithEmail,
    loginWithGoogle,
    loading,
    contextHolder,
  };
};